<template>
  <b-modal v-model="showModal"
           @ok="addReceivedOrder"
           :ok-disabled="isAdding">
    <div slot="modal-title">
      {{ $t('message.received_order.modal_title') }}
    </div>
    <section>
      <span v-html="$t('message.received_order.modal_detail')"></span>
    </section>
    <div slot="modal-cancel" @click="showModal = false">{{ $t('message.button.cancel') }}</div>
    <div slot="modal-ok">
      {{ isAdding ? $t('message.button.loading') : $t('message.button.confirm') }}
    </div>
  </b-modal>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    data () {
      return {
        showModal: false,
        orderId: null,
        selectedIndex: null
      }
    },
    computed: {
      ...mapState('receivedOrder', [
        'isAdding'
      ])
    },
    watch: {
      isAdding () {
        if (!this.isAdding) {
          const data = {
            key: 'is_received_order',
            value: true
          }
          if (this.selectedIndex > -1) {
            // Update received order status for order list
            data.index = this.selectedIndex
            this.$store.commit('order/UPDATE_ORDER_DATA', data)
          } else {
            // Update received order status for order detail
            this.$store.commit('orderDetail/UPDATE_ORDER_DETAIL_DATA', data)
          }
          this.showReceivedOrderModal(false)
          this.$emit('onReceivedOrder', true)
          this.loadOrderDetail(this.orderId)
        }
      }
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      showReceivedOrderModal (status) {
        this.showModal = status
      },
      setOrderData (index, orderId) {
        this.selectedIndex = index
        this.orderId = orderId
      },
      addReceivedOrder (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        const submitData = {
          order_id: this.orderId
        }
        this.$store.dispatch('receivedOrder/ADD_RECEIVED_ORDER', submitData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ReceivedOrderModal.vue